import { render, staticRenderFns } from "./GoForward.vue?vue&type=template&id=e8ee01d0&scoped=true&"
import script from "./GoForward.vue?vue&type=script&lang=js&"
export * from "./GoForward.vue?vue&type=script&lang=js&"
import style0 from "./GoForward.vue?vue&type=style&index=0&id=e8ee01d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ee01d0",
  null
  
)

export default component.exports